import 'url-search-params-polyfill';

import messenger from "./images/messenger.png";
import messenger_2x from "./images/messenger_2x.png";
import mobile_messenger from "./images/mobile_messenger.png";
import mobile_messenger_2x from "./images/mobile_messenger_2x.png";

import music from "./images/music.png";
import music_2x from "./images/music_2x.png";
import mobile_music from "./images/mobile_music.png";
import mobile_music_2x from "./images/mobile_music_2x.png";

import team from "./images/team.png";
import team_2x from "./images/team_2x.png";
import mobile_team from "./images/mobile_team_2x.png";
import mobile_team_2x from "./images/mobile_team_2x.png";

import theme from "./images/theme.png";
import theme_2x from "./images/theme_2x.png";
import mobile_theme from "./images/mobile_theme.png";
import mobile_theme_2x from "./images/mobile_theme_2x.png";


import stories from "./images/stories.png";
import stories_2x from "./images/stories_2x.png";
import mobile_stories from "./images/mobile_stories.png";
import mobile_stories_2x from "./images/mobile_stories_2x.png";


const hostName = window.landing && window.landing.getHostName();

const searchParams = new URLSearchParams(window.location.search);
const langauge = Number(searchParams.get('language'));
const parentLangauge = Number(searchParams.get('parent_language'));
const isEng = langauge === 3 || parentLangauge === 3;

export default {
  hostName: hostName,
  isEng: isEng,
  isGooglePlayAvailable: !isEng,
  sections: [
    {
      id: 1,
      caption:
        isEng ?
        'VK App' :
        'Приложение ВКонтакте',
      slogan:
        isEng ?
        'Send Quick Responses' :
        'Возможность ответить быстро',
      text:
        isEng ?
        'Notifications about&nbsp;new messages will instantly appear on&nbsp;your phone so you’re always in&nbsp;touch.' :
        'Уведомления о&nbsp;новых сообщениях мгновенно приходят на&nbsp;телефон&nbsp;&mdash; вы&nbsp;всегда будете на&nbsp;связи.',
      images: {
        desktop: [messenger, messenger_2x],
        mobile: [mobile_messenger, mobile_messenger_2x]
      }
    },
    {
      id: 2,
      slogan:
        isEng ?
        'Music You Can Take with&nbsp;You' :
        'Музыка, которая всегда с&nbsp;вами',
      text:
        isEng ?
        'All VK music is available on&nbsp;your Android or iOS device.' :
        'Вся музыка ВКонтакте доступна на&nbsp;вашем устройстве на&nbsp;Android или iOS.',
      images: {
        desktop: [music, music_2x],
        mobile: [mobile_music, mobile_music_2x]
      }
    },
    {
      id: 3,
      slogan:
        isEng ?
        'Calls' :
        'Звонки',
      text:
        isEng ?
        'Surprise your friend with a&nbsp;funny mask in a&nbsp;video call or get the whole family together for a&nbsp;group call.' :
        'Удивите друга забавной маской в&nbsp;видеозвонке или создайте групповой звонок и&nbsp;общайтесь всей семьёй.',
      images:{
        desktop: [team, team_2x],
        mobile: [mobile_team, mobile_team_2x]
      }
    },
    {
      id: 4,
      slogan:
        isEng ?
        'Dark Mode' :
        'Тёмная тема',
      text:
        isEng ?
        'Use this mode on&nbsp;VK, and&nbsp;your eyes will thank you.' :
        'Пользуйтесь ВКонтакте так, чтобы ваши глаза были вам благодарны.',
      images: {
        desktop: [theme, theme_2x],
        mobile: [mobile_theme, mobile_theme_2x]
      }
    },
    {
      id: 5,
      slogan:
        isEng ?
        'Convenient Story Editor' :
        'Удобный редактор историй',
      text:
        isEng ?
        'Share exciting moments in&nbsp;stories, tag friends and add hashtags.' :
        'Делитесь яркими моментами в&nbsp;историях, отмечайте друзей и&nbsp;добавляйте хештеги.',
      images: {
        desktop: [stories, stories_2x],
        mobile: [mobile_stories, mobile_stories_2x]
      },
      footer: {
        slogan:
          isEng ?
          'VK Has a&nbsp;Mobile Version as&nbsp;Well' :
          'Но&nbsp;есть и&nbsp;мобильная версия ВКонтакте',
        text:
          isEng ?
          'To access the&nbsp;responsive mobile version of&nbsp;vk.com, just enter the&nbsp;following URL on&nbsp;your phone:' :
          'Для доступа к&nbsp;быстрой мобильной версии сайта ВКонтакте достаточно ввести в&nbsp;вашем телефоне короткий адрес:',
      },
    },
  ],
  page: {
    title: isEng ?
      'Official VK app: download for Android and iOS' :
      'Официальное приложение ВКонтакте: скачать для Android и iOS',
  },
  fixed: {
    directDownloadToAndroid:
      isEng ?
      'Download Directly to Android' :
      'Cкачать напрямую на Android',
    team: isEng ?
      'VK Team' :
      'Команда ВКонтакте',
    vk: isEng ?
      'VK' :
      'ВКонтакте',
    title:
      isEng ?
      'VK Is Always with You' :
      'ВКонтакте всегда с вами',
    description:
      isEng ?
      'Install the official VK app on&nbsp;your phone to&nbsp;chat with others and stay up&nbsp;to&nbsp;date on the&nbsp;latest news no&nbsp;matter where you are.' :
      'Установите официальное приложение ВКонтакте на&nbsp;телефон, общайтесь и&nbsp;следите за&nbsp;новостями, где&nbsp;бы вы&nbsp;ни&nbsp;находились.',
    qrCodeText:
      isEng ?
      'Scan the&nbsp;QR&nbsp;code on&nbsp;your phone to download VK' :
      'Отсканируйте QR-код с&nbsp;помощью телефона, чтобы скачать ВКонтакте',
  }
}
